import * as React from 'react'
import Cascader from 'src/packages/cascader/Cascader'
import Code from 'src/components/Code'
import CodeBox from 'src/components/CodeBox'
import Space from 'src/components/Space'
import { renderString } from 'src/utils/renderCode'

class CascaderExample extends React.Component {
  public static displayName = 'CascaderExample'

  public options = [
    {
      value: 'zhejiang',
      label: 'Zhejiang',
      children: [
        {
          value: 'hangzhou',
          label: 'Hangzhou',
          children: [
            {
              value: 'xihu',
              label: 'West Lake'
            }
          ]
        }
      ]
    },
    {
      value: 'jiangsu',
      label: 'Jiangsu',
      children: [
        {
          value: 'nanjing',
          label: 'Nanjing',
          disabled: true,
          children: [
            {
              value: 'jiangning',
              label: 'Jiangning'
            }
          ]
        }
      ]
    },
    {
      value: 'shanghai',
      label: 'Shanghai',
      children: [
        {
          value: 'pudong',
          label: 'Pudong',
          children: [
            {
              value: 'lujiazhui',
              label: 'Lujiazhui'
            }
          ]
        }
      ]
    }
  ]

  public handleChange = (valueArr: any, selectedOptions: any) => {
    console.log('onChange', valueArr, selectedOptions)
  }

  public handleSelect = (valueArr: any, selectedOptions: any) => {
    console.log('onSelect', valueArr, selectedOptions)
  }

  public render() {
    return (
      <div className="cascader-example">
        <section>
          <h1>Cascader 级联选择</h1>
          <p className="text">级联选择器。</p>
        </section>
        <section>
          <h2>何时使用</h2>
          <p className="text">
            需要从一组层级信息中进行选择时，例如省市区，公司层级，事物分类等。
          </p>
        </section>
        <section>
          <h2>代码示例</h2>
        </section>
        <div className="example">
          <div className="container">
            <Cascader
              options={this.options}
              placeholder="cascader"
              itemStyle={{ minWidth: '130px' }}
              style={{ width: '300px' }}
              onChange={this.handleChange}
              onSelect={this.handleSelect}
            />
          </div>
          <CodeBox
            title="基本用法"
            description="省市区级联，在 options 数组的某一项设置 disabled: true 可以禁用该项。"
          >
            {renderString(`import { Cascader } from 'xue-react'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <span className="property">options</span>
            <span className="htmlstr"> = [</span>
            <br />
            <Space count={4} />
            <span className="htmlstr">{'{'}</span>
            <br />
            <Space count={8} />
            <span className="property">value: </span>
            <span className="string">'zhejiang'</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={8} />
            <span className="property">label: </span>
            <span className="string">'Zhejiang'</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={8} />
            <span className="property">children: </span>
            <span className="htmlstr">[</span>
            <br />
            <Space count={12} />
            <span className="htmlstr">{'{'}</span>
            <br />
            <Space count={16} />
            <span className="property">value: </span>
            <span className="string">'hangzhou'</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={16} />
            <span className="property">label: </span>
            <span className="string">'Hangzhou'</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={16} />
            <span className="property">children: </span>
            <span className="htmlstr">[</span>
            <br />
            <Space count={20} />
            <span className="htmlstr">{'{'}</span>
            <br />
            <Space count={20} />
            <span className="property">value: </span>
            <span className="string">'xihu'</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={20} />
            <span className="property">label: </span>
            <span className="string">'West Lake'</span>
            <br />
            <Space count={20} />
            <span className="htmlstr">{'}'}</span>
            <br />
            <Space count={16} />
            <span className="htmlstr">]</span>
            <br />
            <Space count={12} />
            <span className="htmlstr">{'}'}</span>
            <br />
            <Space count={8} />
            <span className="htmlstr">]</span>
            <br />
            <Space count={4} />
            <span className="htmlstr">{'}'},</span>
            <br />
            <Space count={4} />
            <span className="htmlstr">{'{'}</span>
            <br />
            <Space count={8} />
            <span className="property">value: </span>
            <span className="string">'jiangshu'</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={8} />
            <span className="property">label: </span>
            <span className="string">'Jiangshu'</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={8} />
            <span className="property">children: </span>
            <span className="htmlstr">[</span>
            <br />
            <Space count={12} />
            <span className="htmlstr">{'{'}</span>
            <br />
            <Space count={16} />
            <span className="property">value: </span>
            <span className="string">'nanjing'</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={16} />
            <span className="property">label: </span>
            <span className="string">'Nanjing'</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={16} />
            <span className="property">disabled: </span>
            <span className="htmltag">true</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={16} />
            <span className="property">children: </span>
            <span className="htmlstr">[</span>
            <br />
            <Space count={20} />
            <span className="htmlstr">{'{'}</span>
            <br />
            <Space count={20} />
            <span className="property">value: </span>
            <span className="string">'jiangning'</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={20} />
            <span className="property">label: </span>
            <span className="string">'Jiangning'</span>
            <br />
            <Space count={20} />
            <span className="htmlstr">{'}'}</span>
            <br />
            <Space count={16} />
            <span className="htmlstr">]</span>
            <br />
            <Space count={12} />
            <span className="htmlstr">{'}'}</span>
            <br />
            <Space count={8} />
            <span className="htmlstr">]</span>
            <br />
            <Space count={4} />
            <span className="htmlstr">{'}'},</span>
            <br /> <Space count={4} />
            <span className="htmlstr">{'{'}</span>
            <br />
            <Space count={8} />
            <span className="property">value: </span>
            <span className="string">'shanghai'</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={8} />
            <span className="property">label: </span>
            <span className="string">'Shanghai'</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={8} />
            <span className="property">children: </span>
            <span className="htmlstr">[</span>
            <br />
            <Space count={12} />
            <span className="htmlstr">{'{'}</span>
            <br />
            <Space count={16} />
            <span className="property">value: </span>
            <span className="string">'pudong'</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={16} />
            <span className="property">label: </span>
            <span className="string">'Pudong'</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={16} />
            <span className="property">children: </span>
            <span className="htmlstr">[</span>
            <br />
            <Space count={20} />
            <span className="htmlstr">{'{'}</span>
            <br />
            <Space count={20} />
            <span className="property">value: </span>
            <span className="string">'lujiazhui'</span>
            <span className="htmlstr">,</span>
            <br />
            <Space count={20} />
            <span className="property">label: </span>
            <span className="string">'Lujiazhui'</span>
            <br />
            <Space count={20} />
            <span className="htmlstr">{'}'}</span>
            <br />
            <Space count={16} />
            <span className="htmlstr">]</span>
            <br />
            <Space count={12} />
            <span className="htmlstr">{'}'}</span>
            <br />
            <Space count={8} />
            <span className="htmlstr">]</span>
            <br />
            <Space count={4} />
            <span className="htmlstr">{'}'}</span>
            <br />
            <span className="htmlstr">]</span>
            <br />
            <br />
            <Code
              code={`&lt;Cascader options={this.options} placeholder="cascader" onChange={this.handleChange} onSelect={this.handleSelect} /&gt;`}
            />
          </CodeBox>
        </div>
        <div className="example">
          <div className="container">
            <Cascader
              options={this.options}
              placeholder="cascader"
              changeOnSelect={true}
              onChange={this.handleChange}
              onSelect={this.handleSelect}
              itemStyle={{ minWidth: '130px' }}
              style={{ width: '300px' }}
            />
          </div>
          <CodeBox
            title="选择即展示"
            description="这种模式下父级选项的改变将立即展示。"
          >
            {renderString(`import { Cascader } from 'xue-react'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code
              code={`&lt;Cascader options={this.options} placeholder="cascader" changeOnSelect={true} onChange={this.handleChange} onSelect={this.handleSelect} /&gt;`}
            />
          </CodeBox>
        </div>
        <section>
          <h2>API</h2>
        </section>
        <section className="sub">
          <h3>Cascader</h3>
        </section>
        <table className="api-table">
          <thead>
            <tr>
              <th>参数</th>
              <th className="des">说明</th>
              <th className="type">类型</th>
              <th>默认值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>options</td>
              <td className="des">选项数组，选项具体属性设置见 Option</td>
              <td className="type">Option[]</td>
              <td>——</td>
            </tr>
            <tr>
              <td>placeholder</td>
              <td className="des">input 原生属性</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>changeOnSelect</td>
              <td className="des">每级菜单选项值发生变化是否展示</td>
              <td className="type">boolean</td>
              <td>false</td>
            </tr>
            <tr>
              <td>onChange</td>
              <td className="des">选择完成时的回调</td>
              <td className="type">
                (valueArr: string[], selectedOptions: option[]) => any
              </td>
              <td>——</td>
            </tr>
            <tr>
              <td>onSelect</td>
              <td className="des">选择完成时的回调</td>
              <td className="type">
                (valueArr: string[], selectedOptions: option[]) => any
              </td>
              <td>——</td>
            </tr>
            <tr>
              <td>itemClassName</td>
              <td className="des">自定义子菜单项类名</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>itemStyle</td>
              <td className="des">自定义子菜单项样式</td>
              <td className="type">React.CSSProperties</td>
              <td>——</td>
            </tr>
            <tr>
              <td>className</td>
              <td className="des">自定义 input 框类名</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>style</td>
              <td className="des">自定义 input 框样式</td>
              <td className="type">React.CSSProperties</td>
              <td>——</td>
            </tr>
          </tbody>
        </table>
        <section className="sub">
          <h3>Option</h3>
        </section>
        <table className="api-table">
          <thead>
            <tr>
              <th>参数</th>
              <th className="des">说明</th>
              <th className="type">类型</th>
              <th>默认值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>value</td>
              <td className="des">选项的值</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>label</td>
              <td className="des">选项的标签，用于选择框展示</td>
              <td className="type">string</td>
              <td>false</td>
            </tr>
            <tr>
              <td>children</td>
              <td className="des">子选项数组，选项属性设置同 Option</td>
              <td className="type">Option[]</td>
              <td>——</td>
            </tr>
            <tr>
              <td>disabled</td>
              <td className="des">禁用选项</td>
              <td className="type">boolean</td>
              <td>——</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default CascaderExample



// WEBPACK FOOTER //
// ./src/examples/Cascader.example.tsx